module.exports = __webpack_public_path__ + "static/media/multi.640e37af.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/multi.png
// module id = 455
// module chunks = 0